import AppRoutes from '@/router';

export function App(): JSX.Element {
  return <AppRoutes />;
}

export default App;
